<template>
  <div ref="wrapper">
    <div class="wrapper" :class="classes">
      <div class="element0" @click="navigateToOtherPage(articleUrl)" ref="title">
         <span v-if="computedKeyword" class="keyword" :class="{'keyword--dark-mode': darkMode}">{{ computedKeyword }}</span> <span class="headline">{{ title }}</span>
      </div>

      <div class="element1" @click="navigateToOtherPage(articleUrl)" v-if="animate">
         <span v-if="computedKeyword" class="keyword" :class="{'keyword--dark-mode': darkMode}">{{ computedKeyword }}</span> <span class="headline">{{ title }}</span>
      </div>

    </div>
  </div>
</template>

<script>
import select from '@/store/selectors';
import { PLAYER_NAVIGATE } from '@/utils/messages';

export default {
  data() {
    return {
      animate: false,
      ...this.mapState({
        title: select.episode.title,
        keyword: select.customOptions.keyword,
        articleUrl: select.customOptions.articleUrl,
        darkMode: select.customOptions.darkMode,
      }),
    };
  },
  methods: {
    navigateToOtherPage(url) {
      if (!url) return;

      window.parent.postMessage(
        {
          type: PLAYER_NAVIGATE,
          data: url,
        },
        '*',
      );
    },
  },
  updated() {
    const { title, wrapper } = this.$refs;
    this.animate = wrapper.offsetWidth < title.offsetWidth;
  },
  computed: {
    classes() {
      return {
        title: true,
        'title--dark-mode': this.darkMode,
        animated: this.animate,
        link: this.articleUrl,
      };
    },

    /**
     * Performs operations on `keyword` to make it displayable.
     *
     * @return {string|null} the transformed `keyword` - `null` if it's not present or empty
     */
    computedKeyword() {
      if (!this.keyword) {
        return null;
      }

      return this.keyword.toUpperCase();
    },
  },
};

</script>

<style lang="scss" scoped>
@import '~@/assets/scss/media.scss';

.keyword {
  font-family: "FAZGoldSans-Regular", sans-serif;
  color: #666666;

  &--dark-mode {
    color: #999999;
  }
}

.headline {
  font-family: "FAZGoldSans-Bold", sans-serif;
}

.link {
  cursor: pointer;
}

.title {
  font-size: 13px;
  line-height: 15px;
  position: absolute;
  padding: 0 11px;
  transform: translateX(0);
  white-space: nowrap;
  min-width: 100%;
  color: #000000;

  &--dark-mode {
    color: #FFFFFF;
  }

  @include only-desktop {
    padding: 0;
  }
}

.wrapper {
  overflow: hidden;
  white-space: nowrap;

  > * {
    display: inline-block;
    white-space: nowrap;
    padding-right: 30px;
  }
}

.animated{
  .element0, .element1 {
    transform: translateX(0);
    animation: 15s linear 3s infinite slide;
  }
}

@keyframes slide {
    0% {
      transform: translateX(0)
    }

    75% {
      transform: translateX(-100%);
    }

    100% {
        transform: translateX(-100%);
    }
}
</style>
